import { ReactNode } from 'react'
import { createPortal } from 'react-dom'

export const Portal = ({ children }: { children: ReactNode }) => {
  // https://blog.logrocket.com/learn-react-portals-example/
  const portalRoot: any = document.getElementById('swap-page')
  return createPortal(children, portalRoot)
}
